<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="tournament-card-preview" elevation="1">
      <div class="tournament-card-header header-live">
        <div class="">
          <span class="label-theme"
            ><v-icon>mdi-view-day</v-icon> {{ $t('eventsDay') }}
          </span>
        </div>
      </div>

      <div
        class="sport-next-events-content"
        v-if="!this.checkIsMobile() && !this.checkIsTablet()"
      >
        <v-tabs
          background-color="dark accent-4"
          center-active
          show-arrows
          dark
          class="tabs-live"
        >
          <v-tab
            v-for="(item, index) in getSports"
            :key="`single_tab_img_event_day` + item.id"
            @click="changeEventsDay(item.id)"
          >
            <div class="single-tab">
              <img
                :src="sportPath + returnIcon(getIcon) + '/' + item.id + '.svg'"
                :alt="item.name"
                class="sport-icon"
                v-bind:class="{ 'img-sport-light': light }"
              />
              <span class="text-sport">{{ item.name }}</span>
            </div>
          </v-tab>
        </v-tabs>
        <v-progress-linear
          indeterminate
          color="primary darken-2"
          v-if="this.loading"
        ></v-progress-linear>
        <div class="preview">
          <template v-if="!this.loading || this.getEventsDay.length > 0">
            <v-card class="tournament-card-preview" elevation="1">
              <div class="tournament-card-events">
                <div class="bar-info" v-if="Object.keys(markets).length > 0">
                  <v-col cols="12" md="5" class="no-padding">
                    <span class="date"></span>
                  </v-col>
                  <v-col
                    cols="12"
                    :md="Object.keys(markets).length == 1 ? 6 : 3"
                    class="no-padding group-sign"
                    v-for="(market, index) in markets"
                    v-if="index < 2"
                    :key="$uuid.v1()"
                  >
                    <span
                      class="sign"
                      v-for="(outcome, index) in market.outcomes"
                      :key="$uuid.v1()"
                    >
                      {{ outcome.name }} {{ getSpecifiers(market.specifiers) }}
                    </span>
                  </v-col>
                  <v-col cols="12" md="1" class="no-padding">
                    {{ markets.length }}
                  </v-col>
                </div>
                <v-col
                  cols="12"
                  class="tournament-card-events info-event event"
                  align="center"
                  justify="center"
                  v-else
                >
                  <div
                    class="message align-center align-self-center"
                    style="width: 100%"
                  >
                    <span class="title">{{ $t('noevent') }}</span>
                    <br />
                    <span class="subTitle">{{ $t('subnoevent') }}</span>
                  </div>
                </v-col>
                <div
                  class="event"
                  v-for="(event, index) in this.getEventsDay"
                  :key="$uuid.v1()"
                  :class="index % 2 == 0 ? 'even' : 'odd'"
                  v-if="event.events_sources.length > 0"
                >
                  <v-col cols="12" md="5" class="no-padding info-event">
                    <span class="info-match info-next">
                      <span class="time">{{
                        new Date(event.events[0].scheduled).toLocaleTimeString(
                          [],
                          {
                            hour: '2-digit',
                            minute: '2-digit',
                          }
                        )
                      }}</span>
                      <span
                        v-if="
                          getUserType == 4 ||
                          getCashier ||
                          !getSettings.enableQuickBetOnlyForAgency
                        "
                        class="event-qbet"
                        title="qbet"
                      >
                        {{ event.events[0].quickbet }}
                      </span>
                    </span>
                    <span class="competitors">
                      <span class="home">{{
                        event.events[0].competitors.home.name
                      }}</span>
                      <span class="away">{{
                        event.events[0].competitors.away.name
                      }}</span>
                      <span class="path">
                        {{ event.category.name
                        }}<v-icon dense x-small>mdi-chevron-right</v-icon>
                        {{ event.tournament.name }}
                      </span>
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    :md="Object.keys(markets).length == 1 ? 6 : 3"
                    class="no-padding group-sign"
                    v-for="(oddMarket, index) in event.events[0].odds"
                    :key="$uuid.v1()"
                    v-if="index < 2"
                  >
                    <div
                      v-if="!oddMarket.void"
                      class="odd"
                      v-for="(odd, index) in oddMarket.odds"
                      :key="$uuid.v1()"
                    >
                      <v-icon class="arrow-up" v-if="odd.type_change == 'up'"
                        >mdi-arrow-up
                      </v-icon>
                      <v-icon
                        class="arrow-down"
                        v-if="odd.type_change == 'down'"
                        >mdi-arrow-down
                      </v-icon>
                      <div
                        v-if="odd.outcome_odd_value > 0 && odd.active"
                        class="value"
                        :class="[
                          'multi-' + oddMarket.multiplicity_min,
                          getOddsSources.includes(odd.unique_id)
                            ? 'odd_selected'
                            : '',
                        ]"
                        @click="
                          putCart(
                            odd,
                            event.events[0],
                            event.sport,
                            event.category,
                            event.tournament
                          )
                        "
                      >
                        <div
                          :class="[
                            odd.type_change != undefined
                              ? odd.type_change
                              : 'equal',
                          ]"
                        ></div>
                        {{ odd.outcome_odd_value | odds_type_filter }}
                      </div>
                      <div
                        v-else
                        class="value"
                        :class="'multi-' + oddMarket.multiplicity_min"
                      >
                        <v-icon dense>mdi-lock</v-icon>
                      </div>
                    </div>

                    <div
                      v-if="oddMarket.void"
                      class="odd"
                      v-for="n in oddMarket.n_outcomes"
                      :key="$uuid.v1()"
                    >
                      <div
                        class="value locked"
                        :class="'multi-' + oddMarket.multiplicity_min"
                      >
                        <v-icon dense>mdi-lock</v-icon>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="1" class="no-padding group-sign">
                    <div class="odd">
                      <div
                        v-if="event.events[0].count_odds > 0"
                        class="value"
                        @click="
                          getDetailOfEvent(
                            event.events[0].id,
                            event.events[0].type,
                            event.sport.id,
                            event.tournament.id ? event.tournament.id : '',
                            event.events[0].status
                          )
                        "
                        v-bind:class="{
                          'detail-opened': getEventsDetailActive.includes(
                            event.events[0].id
                          ),
                        }"
                      >
                        <span v-if="getOddsType == 'decimal'"
                          >+ {{ event.events[0].count_odds }}</span
                        >
                        <span v-if="getOddsType == 'american'">{{
                          $t('moreBets')
                        }}</span>
                      </div>
                      <div v-else class="value locked">
                        <v-icon dense>mdi-lock</v-icon>
                      </div>
                    </div>
                  </v-col>
                </div>
              </div>
            </v-card>

            <div
              v-if="
                getCountEventsDay.length > 0 && getCountEventsDay[0].total > 0
              "
            >
              <div
                v-if="
                  getCountEventsDay[0].count + getCountEventsDay[0].skip !=
                  getCountEventsDay[0].total
                "
              >
                <div
                  class="text-center pb-2"
                  @click="
                    getDataEventsDayMore(
                      getCountEventsDay[0].total,
                      getCountEventsDay[0].skip,
                      getCountEventsDay[0].count
                    )
                  "
                >
                  <span class="action-btn show-others" :title="$t('loadmore')"
                    >{{ $t('loadmore') }}
                    <v-icon dense>mdi-chevron-right</v-icon></span
                  >
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <v-skeleton-loader
              v-bind="attrs"
              type="article,article,article"
            ></v-skeleton-loader>
          </template>
        </div>
        <v-progress-linear
          indeterminate
          color="primary darken-2"
          v-if="this.loadingmore"
        ></v-progress-linear>
      </div>
      <div
        class="sport-next-events-content sport-ne-mobile"
        v-else-if="this.checkIsMobile() || this.checkIsTablet()"
      >
        <v-slide-group show-arrows class="pt-2 pb-2" active-class="success">
          <v-slide-item
            v-for="(item, index) in this.getSports"
            :key="$uuid.v1()"
          >
            <v-btn
              small
              class="mx-2"
              depressed
              rounded
              @click="changeEventsDay(item.id)"
              :class="sport_active == item.id ? 'active-sport' : ''"
            >
              <span class="text-sport text-capitalize">{{ item.name }}</span>
              <!--              <span class="count">{{ item.count }}</span>-->
            </v-btn>
          </v-slide-item>
        </v-slide-group>
        <v-progress-linear
          indeterminate
          color="primary darken-2"
          v-if="this.loading"
        ></v-progress-linear>
        <div class="preview" v-if="!this.loading">
          <v-card class="tournament-card-preview" elevation="1">
            <div class="tournament-card-events">
              <div class="bar-info" v-if="Object.keys(markets).length > 0">
                <v-col :xs="4" class="no-padding left-info">
                  <span class="date"></span>
                </v-col>
                <v-col
                  :xs="8"
                  class="no-padding group-sign"
                  v-for="(market, index) in markets"
                  v-if="index == 0 && markets.length > 0"
                  :key="$uuid.v1()"
                >
                  <span
                    class="sign"
                    v-for="(outcome, index) in market.outcomes"
                    :key="$uuid.v1()"
                  >
                    {{ outcome.name }}
                  </span>
                </v-col>
              </div>

              <div
                class="event"
                v-for="(event, index) in this.getEventsDay"
                :key="$uuid.v1()"
                :class="index % 2 == 0 ? 'even' : 'odd'"
                v-if="event.events_sources.length"
              >
                <v-col
                  :xs="4"
                  class="no-padding info-event"
                  @click="
                    getDetailOfEvent(
                      event.events[0].id,
                      event.events[0].type,
                      event.sport.id,
                      event.tournament.id ? event.tournament.id : '',
                      event.events[0].status
                    )
                  "
                >
                  <span class="competitors">
                    <span class="path">
                      <!--                      {{event.category.name}}<v-icon dense x-small>mdi-chevron-right</v-icon> -->
                      <!--                      {{event.tournament.name}}-->
                    </span>
                    <span class="time">
                      <v-icon x-small>mdi-timer</v-icon>
                      {{
                        new Date(event.events[0].scheduled).toLocaleTimeString(
                          [],
                          { hour: '2-digit', minute: '2-digit' }
                        )
                      }}
                    </span>
                    <span class="home">{{
                      event.events[0].competitors.home.name | truncate(26, '')
                    }}</span>
                    <span class="away">{{
                      event.events[0].competitors.away.name | truncate(26, '')
                    }}</span>
                    <span class="time"
                      >{{ event.tournament.name | truncate(19, '..') }}
                    </span>
                  </span>
                </v-col>
                <v-col
                  :xs="8"
                  class="no-padding group-sign"
                  v-for="(oddMarket, index) in event.events[0].odds"
                  :key="$uuid.v1()"
                  v-if="index == 0"
                >
                  <div
                    v-if="!oddMarket.void"
                    class="odd"
                    v-for="(odd, index) in oddMarket.odds"
                    :key="$uuid.v1()"
                  >
                    <v-icon class="arrow-up" v-if="odd.type_change == 'up'"
                      >mdi-arrow-up</v-icon
                    >
                    <v-icon class="arrow-down" v-if="odd.type_change == 'down'"
                      >mdi-arrow-down
                    </v-icon>
                    <div
                      v-if="odd.outcome_odd_value > 0 && odd.active"
                      class="value"
                      :class="[
                        'multi-' + oddMarket.multiplicity_min,
                        getOddsSources.includes(odd.unique_id)
                          ? 'odd_selected'
                          : '',
                      ]"
                      @click="
                        putCart(
                          odd,
                          event.events[0],
                          event.sport,
                          event.category,
                          event.tournament
                        )
                      "
                    >
                      <div
                        :class="[
                          odd.type_change != undefined
                            ? odd.type_change
                            : 'equal',
                        ]"
                      ></div>
                      {{ odd.outcome_odd_value | odds_type_filter }}
                    </div>
                    <div
                      v-else
                      class="value"
                      :class="'multi-' + oddMarket.multiplicity_min"
                    >
                      <v-icon dense>mdi-lock</v-icon>
                    </div>
                  </div>

                  <div
                    v-if="oddMarket.void"
                    class="odd"
                    v-for="n in oddMarket.n_outcomes"
                    :key="$uuid.v1()"
                  >
                    <div
                      class="value locked"
                      :class="'multi-' + oddMarket.multiplicity_min"
                    >
                      <v-icon dense>mdi-lock</v-icon>
                    </div>
                  </div>
                </v-col>
              </div>
            </div>
          </v-card>
          <div
            v-if="
              getCountEventsDay.length > 0 && getCountEventsDay[0].total > 0
            "
          >
            <div
              v-if="
                getCountEventsDay[0].count + getCountEventsDay[0].skip !=
                getCountEventsDay[0].total
              "
            >
              <div
                class="text-center pb-2"
                @click="
                  getDataEventsDayMore(
                    getCountEventsDay[0].total,
                    getCountEventsDay[0].skip,
                    getCountEventsDay[0].count
                  )
                "
              >
                <span class="action-btn show-others" :title="$t('loadmore')"
                  >{{ $t('loadmore') }}
                  <v-icon dense>mdi-chevron-right</v-icon></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>
    <v-dialog
      v-if="noStatsAvailable"
      transition="dialog-top-transition"
      max-width="700"
      v-model="noStatsAvailable"
      content-class="modal-on-top"
    >
      <v-card class="text-center pt-15 pb-15">
        <v-col cols="12">
          <v-icon x-large @click="noStatsAvailable = false"
            >mdi-close-circle</v-icon
          >
        </v-col>
        <v-col cols="12" class="message-bet-success">
          <span class="ml-2 text-uppercase">{{
            this.formatMessage(error_code)
          }}</span
          ><br />
          <span style="font-size: 12px">{{
            this.formatMessage(error_reason)
          }}</span>
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from 'lodash'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import axios from 'axios'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '../../../plugins/device-inspector'

export default {
  name: 'DefaultEventsDayWidgetServer',
  data: () => ({
    attrs: {
      class: 'mb-6',
      boilerplate: true,
      elevation: 0,
    },
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    limit: 5,
    livesCount: [],
    loading: false,
    loadingmore: false,
    noStatsAvailable: false,
    markets: [],
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT + '/category-images/rectangular/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/',
    sport_active: null,
    light: window.icons == 'light' ? true : false,
    skip: 0,
    overlay: false,
    error_reason: '',
    error_code: '',
  }),
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getFilter: 'tree/getFilter',
      getEventsDay: 'odds/getEventsDay',
      getCountEventsDay: 'odds/getCountEventsDay',
      getEventsDetailActive: 'odds/getEventsDetailActive',
      getLoadingPreview: 'odds/getLoadingPreview',
      getOddsSources: 'cart/getOddsSources',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getPlatformId: 'settings/getPlatformId',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
      getUserTimezone: 'user/getTimezone',
      getUserLanguage: 'user/getLanguage',
      getDaySkip: 'odds/getDaySkip',
      getDayLimit: 'odds/getDayLimit',
      getSports: 'sport/getItems',
      getIcon: 'settings/getIcon',
      getOddsType: 'odds/getOddsType',
    }),
    listSports: function () {
      if (_.size(this.getSports) > 0) {
        const clean = []
        _.forEach(this.getSports, el => {
          clean.push(el)
        })
        return clean
      }
    },
  },

  methods: {
    ...mapActions({
      setFilter: 'tree/setFilter',
      removeFromPreview: 'odds/removeFromPreview',
      fetchEventDetail: 'odds/fetchEventDetail',
      fetchEventLiveDetail: 'odds/fetchEventLiveDetail',
      setLoadingPreview: 'odds/setLoadingPreview',
      setLoadingLive: 'odds/setLoadingLive',
      addOddToCart: 'cart/addOddToCart',
      fetchLive: 'odds/fetchLive',
      fetchEventsDay: 'odds/fetchEventsDayServer',
      fetchEventsDayMore: 'odds/fetchEventsDayMoreServer',
      setLiveMode: 'odds/setLiveMode',
      setDayLimit: 'odds/setDayLimit',
      setDaySkip: 'odds/setDaySkip',
      fetchSports: 'sport/fetchSports',
    }),
    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },
    formatMessage(msg) {
      return unescape(msg)
    },
    async openStats(id_event, tournament, sport, status) {
      let checkSkin = _.find(this.getRulesSkin, {
        type: 'statscoreprematch',
        source: sport,
        status: true,
      })
      if (!checkSkin) {
        checkSkin = _.find(this.getRulesManager, {
          type: 'statscoreprematch',
          source: sport,
          status: true,
        })
      }

      if (checkSkin) {
        if (id_event && checkSkin) {
          const result = await axios({
            method: 'get',
            url:
              'https://api.statscore.com/v2/booked-events?client_id=1256&product=prematchcenter&events_details=no&client_event_id=' +
              id_event,
            headers: {
              'content-type': 'application/json',
            },
          })

          if (result.data.api.method.total_items > 0) {
            const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1000,top=-1000`

            const routeData = this.$router.resolve({
              path: '/statistics',
              query: {
                id_event: id_event,
                tournament: tournament,
                sport: sport,
                status: true,
              },
            })
            window.open(routeData.href, 'detail', params)
          } else {
            this.error_code = 'Attention!!'
            this.error_reason = 'No data for this events avaiables'
            this.noStatsAvailable = true
          }
        }
      }
    },
    returnIcon(icon) {
      let response
      switch (icon) {
        case 'B/W':
          response = 'icons'
          break
        case 'Color':
          this.light = false
          response = 'icons_color'
          break
      }
      return response
    },
    async changeEventsDay(sport) {
      this.sport_active = sport
      this.loading = true
      await this.setDaySkip({ daySkip: 0 })
      await this.fetchEventsDay({
        sport: sport,
        group: false,
        language_user: this.getLanguage,
        timezone: this.getUserTimezone,
        forceDefaultGameConsole: false,
      })
      if (_.size(this.getEventsDay) > 0) {
        this.markets = this.getEventsDay[0].markets
      } else {
        this.markets = []
      }
      this.loading = false
    },
    getTitle(item) {
      return _.find(item.detail, { lang: this.getLanguage }).text
    },
    async getDataEventsDay() {
      this.loading = true
      await this.setDaySkip({ daySkip: 0 })
      await this.fetchEventsDay({
        sport: sport.id,
        sport_id: sport._id,
        group: false,
        language_user: this.getLanguage,
        timezone: this.getUserTimezone,
        forceDefaultGameConsole: false,
      })
      if (_.size(this.getEventsDay) > 0) {
        this.markets = this.getEventsDay[0].markets
      } else {
      }
      this.loading = false
    },
    async getDataEventsDayMore(total, skip, count) {
      const lastItem = _.last(this.getEventsDay)
      await this.setDaySkip({ daySkip: this.getDaySkip + this.getDayLimit })
      const eventId = lastItem.events[0].id
      this.loadingmore = true
      await this.setLoadingPreview({ status: true })
      await this.fetchEventsDayMore({
        sport: this.sport_active,
        language_user: this.getLanguage,
        timezone: this.getUserTimezone,
        skip: this.getDaySkip,
        limit: this.getDayLimit,
        forceDefaultGameConsole: false,
      })
      this.loadingmore = false
    },
    groupByDate(events) {
      const refactored = _.groupBy(events, 'day')
      return refactored
    },
    increaseLimit() {
      this.limit = this.limit + this.offset
    },
    getRandomInt(min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    async putCart(odd, event, sport, category, tournament) {
      if (parseFloat(odd.outcome_odd_value) > 0 && odd.active) {
        await this.addOddToCart({
          odd: odd,
          event: event,
          sport: sport,
          category: category,
          tournament: tournament,
        })
        this.$root.$emit('forceUpdateSingleMultiple')
        this.$root.$emit('forceUpdateIntegral')
        this.$root.$emit('forceUpdateSystem')
      }
    },

    async getDetailOfEvent(eventSource, type, sport, tournament, status) {
      this.overlay = true
      document.body.scrollIntoView({ behavior: 'smooth' })
      window.parent.postMessage(
        {
          type: 'scrollTop',
        },
        '*'
      )
      //console.log(eventSource)
      await this.setLoadingPreview({ status: true })
      await this.fetchEventDetail({
        source: eventSource,
        group: 0,
        sport: sport,
        tournament: tournament,
        status: status,
      })
      await this.setLoadingPreview({ status: false })
      this.overlay = false
    },

    getSpecifiers(spec) {
      let result = ''

      if (spec.includes('#')) {
        const split = spec.split('#')
        if (split[1].includes(':')) {
          result = '(' + split[1] + ')'
        } else if (split[1].includes('(') && split[1].includes('.')) {
          result = ' [' + split[1] + '] '
        } else if (split[1] != '') {
          result = split[1]
        }

        if (_.size(split) > 2) {
          return result + ' ' + split[2]
        } else {
          return result
        }
      } else {
        return result
      }
    },
  },
  watch: {
    async getSports(val) {
      if (_.size(val) > 0) {
        await this.setDaySkip({ daySkip: 0 })
        this.sport_active = this.getSports[0].id
        await this.fetchEventsDay({
          sport: this.sport_active,
          group: false,
          language_user: this.getLanguage,
          timezone: this.getUserTimezone,
          forceDefaultGameConsole: false,
        })
        if (_.size(this.getEventsDay) > 0) {
          this.markets = this.getEventsDay[0].markets
          this.sport_active = this.getEventsDay[0].sport.id
        }
      } else {
        this.loading = true
      }
    },
  },

  mounted() {
    // console.log('mounted DefaultEventsDayWidgetServer')
  },
}
</script>
<style>
.img-sport-light {
  filter: invert(1);
}

.img-sport-dark {
  filter: invert(0);
}
</style>
